export default __webpack_public_path__ + "static/media/comedy.d7cf2782.jpg";